import { graphql } from "~/gql";

export const FIND_ACCRUED_FEES_FOR_MATTER = graphql(/* GraphQL */ `
  query findAccruedFeesForMatter($id: Float!) {
    findAccruedFeesForMatter(id: $id) {
      ...AccruedFeeFragment
    }
  }
`);
